import PropTypes from 'prop-types'
import React from 'react'

export default function ProductDescription({ t, description }) {
  if (!description) return null

  return (
    <div className="product-addition">
      <h2 className="product-addition-headline">{t('components.productComponent.description')}</h2>
      <div
        className="product-addition-content"
        itemProp="description"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  )
}

ProductDescription.propTypes = {
  t: PropTypes.func.isRequired,
  description: PropTypes.string,
}
